//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DropdownArrow',
  props: {
    rotated: {
      type: Boolean,
      default: false,
    },
  },
}
